import axios from "axios";
import store from "../store/store";

const AXIOS = axios.create({
  baseURL: "/api",
  timeout: 10000,
});

const setLocalStorage = (data, headers) => {
  localStorage.setItem("token-key", headers["token-key"]);
  localStorage.setItem("token-setup", headers["token-setup"]);
  localStorage.setItem("username", data.data.username);
  localStorage.setItem("memberType", data.data.memberType);
  localStorage.setItem("lastLogin", data.data.lastLogin);

  localStorage.setItem("knowledgeBoard", data.data.knowledgeBoard);
  localStorage.setItem("parentBulletinBoard", data.data.parentBulletinBoard);
  localStorage.setItem("blog", data.data.blog);
  localStorage.setItem("financeBoard", data.data.financeBoard);
  localStorage.setItem("comment", data.data.comment);
  localStorage.setItem("english", data.data.english);
  localStorage.setItem("exercise", data.data.exercise);
  localStorage.setItem("humor", data.data.humor);
  localStorage.setItem("it", data.data.it);
  localStorage.setItem("bongGu", data.data.bongGu);
  localStorage.setItem("realEstateBoard", data.data.realEstateBoard);
  localStorage.setItem("travel", data.data.travel);
  localStorage.setItem("privateBulletinBoard", data.data.privateBulletinBoard);
  localStorage.setItem("bulletinBoard", data.data.bulletinBoard);
  localStorage.setItem("todayIssue", data.data.todayIssue);
};

const setLocalStorageNewTokenKey = (data, headers) => {
  localStorage.setItem("token-key", headers["new-token-key"]);
  store.dispatch("REQUEST_GET_INFO", localStorage.getItem("token-key"));

  localStorage.setItem("lastLogin", data.data.lastLogin);

  localStorage.setItem("knowledgeBoard", data.data.knowledgeBoard);
  localStorage.setItem("parentBulletinBoard", data.data.parentBulletinBoard);
  localStorage.setItem("blog", data.data.blog);
  localStorage.setItem("financeBoard", data.data.financeBoard);
  localStorage.setItem("comment", data.data.comment);
  localStorage.setItem("english", data.data.english);
  localStorage.setItem("exercise", data.data.exercise);
  localStorage.setItem("bongGu", data.data.bongGu);
  localStorage.setItem("humor", data.data.humor);
  localStorage.setItem("it", data.data.it);
  localStorage.setItem("realEstateBoard", data.data.realEstateBoard);
  localStorage.setItem("travel", data.data.travel);
  localStorage.setItem("privateBulletinBoard", data.data.privateBulletinBoard);
  localStorage.setItem("bulletinBoard", data.data.bulletinBoard);
  localStorage.setItem("todayIssue", data.data.todayIssue);
};

const setLocalStorageExpiredStatus = (data) => {
  localStorage.setItem("expiredStatus", data.expiredStatus);
  if (data.statusCode == 500) {
    store.dispatch("MATCH_INFO", localStorage.getItem("token-setup"));
  }
};

const clearLocalStorage = () => {
  localStorage.removeItem("token-key");
  localStorage.removeItem("token-setup");
  localStorage.removeItem("username");
  localStorage.removeItem("password");
  localStorage.removeItem("memberType");
  localStorage.removeItem("expiredStatus");
  localStorage.removeItem("lastLogin");

  localStorage.removeItem("financeBoard");
  localStorage.removeItem("comment");
  localStorage.removeItem("english");
  localStorage.removeItem("exercise");
  localStorage.removeItem("bongGu");
  localStorage.removeItem("humor");
  localStorage.removeItem("it");
  localStorage.removeItem("realEstateBoard");
  localStorage.removeItem("travel");
  localStorage.removeItem("privateBulletinBoard");
  localStorage.removeItem("bulletinBoard");
  localStorage.removeItem("todayIssue");

  localStorage.removeItem("knowledgeBoard");
  localStorage.removeItem("parentBulletinBoard");
  localStorage.removeItem("blog");

  store.commit("INIT");
  store.state.common.isOkayCheck = false;

  // AXIOS.defaults.headers.common['token-key'] = null;
};

export {
  setLocalStorage,
  clearLocalStorage,
  setLocalStorageNewTokenKey,
  setLocalStorageExpiredStatus,
};
